export interface INotificationTemplate {
  id?: number;
  type?: string;
  medium?: string;
  language?: string;
  message?: string;
}

export const defaultValue: Readonly<INotificationTemplate> = {};
